import storage from './storage';

const K = 'crm_snippet_templates_v1';

const DEFAULTS = {
  noteByBranch: [
    { id: 'nb1', branch: 'Holzbau', text: 'Baustelle / Zimmerei: Ansprechpartner GF, Bedarf Fachkräfte, nächster Schritt: Angebot Unterlagen.' },
    { id: 'nb2', branch: 'SHK', text: 'SHK: Wartungsvertrag / Projekte, Entscheider Technik/Einkauf, Termin Setting vorschlagen.' },
  ],
  noteByStatus: [
    { id: 'ns1', status: 'interessiert', text: 'Interesse bestätigt, nächste Woche Demo-Termin, offene Fragen: Budget, Timeline.' },
    { id: 'ns2', status: 'nachgefasst', text: 'Nachgefasst – noch keine Rückmeldung, Alternative: Kurz-Mail mit 2 Terminvorschlägen.' },
  ],
  emailByBranch: [
    { id: 'eb1', branch: 'Elektro', subject: 'Kurzes Update zu unserem Gespräch', body: 'Hallo {{vorname}},\n\nbezüglich {{firma}} wollte ich kurz nachhaken …\n\nViele Grüße' },
  ],
  whatsappDefault: {
    text: 'Hallo {{vorname}}, kurze Rückfrage zu {{firma}} – haben Sie gerade 2 Minuten Zeit?',
  },
};

export const crmSnippetTemplates = {
  get() {
    return storage.get(K, DEFAULTS);
  },
  set(data) {
    storage.set(K, { ...DEFAULTS, ...data });
  },
  updateCategory(cat, items) {
    const cur = this.get();
    this.set({ ...cur, [cat]: items });
  },
};
